import KeenSlider from 'keen-slider';

export const HistoryCarousel = {
    init: function () {
        this.cacheSelectors();
        this.bindEvents();
    },

    cacheSelectors: function () {
        this.sliderElement = document.querySelector('#history--slider');
        this.prevButton = document.querySelector('#section_history .arrow__prev');
        this.nextButton = document.querySelector('#section_history .arrow__next');
    },

    bindEvents: function () {
        if (!this.sliderElement) {
            return;
        }
        const options = this.getOptions();
        this.sliderInstance = new KeenSlider(this.sliderElement, options, [
            (slider) => this.initializeSlider(slider),
        ]);
    },

    getOptions: function () {
        return {
            loop: false,
            mode: 'free-snap',
            rtl: false,
            slides: {
                perView: 1,
                spacing: 15,
            },
        };
    },

    initializeSlider: function (slider) {
        const images = document.querySelectorAll(".history .images img");


        const updateButtons = () => {
            const { rel, slides } = slider.track.details;

            images.forEach((item) => {
                item.style.display = "none";
            });

            images[rel].style.display = "block";

            if (this.prevButton) {
                this.prevButton.classList.toggle('arrow--disabled', rel === 0);
            }
            if (this.nextButton) {
                this.nextButton.classList.toggle('arrow--disabled', rel === slides.length - 1);
            }
        };

        this.prevButton?.addEventListener('click', () => slider.prev());
        this.nextButton?.addEventListener('click', () => slider.next());

        slider.on('created', updateButtons);
        slider.on('slideChanged', updateButtons);
    },
};



HistoryCarousel.init();


